import { render, staticRenderFns } from "./MaterialsAssignedToStudent.vue?vue&type=template&id=2db7f301"
import script from "./MaterialsAssignedToStudent.vue?vue&type=script&lang=js"
export * from "./MaterialsAssignedToStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports